<template>
  <sModal
    v-model="view"
    :content-class-name="'pl-5 pr-5 pt-5 pb-2'"
    :title="document ? document.title : ''"
    @close="hideDocumentView">
    <DocumentView
      ref="documentView"
      class="questions-document-view"
      :file="document"
      @changeLink="checkPrintBtn"/>
    <div
      key="footer"
      slot="footer"
      class="document-view-footer flex-between">
      <sButton
        key="btn-close"
        type="text"
        @click="hideDocumentView">
        {{ $t('Common.Close') }}
      </sButton>
      <div
        key="document-buttons"
        class="flex flex-wrap flex-right">
        <sButton
          key="btn-download"
          icon="download"
          type="text"
          @click="document.saveFile()">
          {{ $t('Tenders.Download') }}
        </sButton>
        <sButton
          v-if="showPrint"
          key="btn-print"
          icon="printer"
          type="text"
          @click="$refs.documentView.printDocument()">
          {{ $t('Tenders.Print') }}
        </sButton>
      </div>
    </div>
  </sModal>
</template>
<script>
import DocumentView from 'components/common/elements/DocumentView.vue'

export default {
  name: 'modalDocumentView',
  data() {
    return {
      showPrint: false,
      view: false,
    }
  },
  methods: {
    checkPrintBtn() {
      this.showPrint = false
      if (!this.$refs?.documentView) {
        return
      }
      this.showPrint = !!this.$refs.documentView.img_type || !!this.$refs.documentView.html_type || !!this.$refs.documentView.pdf_type
    },
    hideDocumentView() {
      this.$nextTick(() => {
        this.view = false
      })
      this.$emit('update:document', null)
    }
  },
  watch: {
    document: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.view = true
          })
        } else {
          this.hideDocumentView()
        }
      }
    }
  },
  props: {
    document: {
      type: Object,
    }
  },
  components: {
    DocumentView
  }
}
</script>
<style scoped>
.document-view-footer {
  text-align: right;
  background: var(--v-main__green-base);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 0 0 5px 5px;
  padding: 10px;
}
.questions-document-view {
  height: calc(70vh - 35px) !important;
}
</style>
